/* eslint-disable @typescript-eslint/no-floating-promises */
/** @jsxRuntime classic */
// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-app-polyfill/ie11';
// eslint-disable-next-line import/no-extraneous-dependencies
import 'react-app-polyfill/stable';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';

import App from './App';
// import reportWebVitals from './reportWebVitals';

// Load Honeycomb CSS
/* eslint-disable import/no-extraneous-dependencies */
import '@honeycomb-npm/honeycomb/src/bundles/honeycomb.scss';
import { store } from './stories/store';
import ThemeWrapper from './ThemeWrapper';
import ErrorBoundary from './components/ErrorBoundary';

const renderApp = () => {
    const container = document.getElementById('root');

    if (container) {
        const root = createRoot(container);

        root.render(
            <Provider store={store}>
                <ErrorBoundary>
                    <ThemeWrapper>
                        <App />
                    </ThemeWrapper>
                </ErrorBoundary>
            </Provider>,
        );
    }
};

if (process.env.NODE_ENV === 'development') {
    const startWorker = async () => {
        const { worker } = await import('./mocks/browser');

        await worker.start({
            onUnhandledRequest: 'bypass',
        });
    };

    startWorker().then(() => renderApp());
} else {
    renderApp();
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
